import { render, staticRenderFns } from "./EditTeachingField.vue?vue&type=template&id=5ba6f315&scoped=true&"
import script from "./EditTeachingField.vue?vue&type=script&lang=js&"
export * from "./EditTeachingField.vue?vue&type=script&lang=js&"
import style0 from "./EditTeachingField.vue?vue&type=style&index=0&id=5ba6f315&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6f315",
  null
  
)

export default component.exports